import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  margin-bottom: 1em;\n  @media screen and (max-width: ', ') {\n    position: initial;\n    text-align: right;\n  }\n'], ['\n  margin-bottom: 1em;\n  @media screen and (max-width: ', ') {\n    position: initial;\n    text-align: right;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  text-transform: uppercase;\n  text-decoration: underline;\n'], ['\n  text-transform: uppercase;\n  text-decoration: underline;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: 24px;\n  border-bottom: 1px solid ', ';\n  padding: 0.5em 0;\n  text-align: center;\n  font-weight: 600;\n'], ['\n  font-size: 24px;\n  border-bottom: 1px solid ', ';\n  padding: 0.5em 0;\n  text-align: center;\n  font-weight: 600;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  padding: 1em 0;\n  text-align: center;\n'], ['\n  padding: 1em 0;\n  text-align: center;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  font-size: 20px;\n  margin-bottom: 0.5em;\n  text-transform: uppercase;\n  font-weight: 600;\n'], ['\n  font-size: 20px;\n  margin-bottom: 0.5em;\n  text-transform: uppercase;\n  font-weight: 600;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  font-size: 16px;\n'], ['\n  font-size: 16px;\n']);

import styled from 'styled-components';

export var StyledWrapper = styled.div(_templateObject, function (props) {
  return props.theme.tabletWidth;
});

export var StyledButton = styled.button(_templateObject2);

export var StyledModalHeader = styled.h3(_templateObject3, function (props) {
  return props.theme.dormifyLightGrey;
});

export var StyledModalDiv = styled.div(_templateObject4);

export var StyledModalSubheader = styled.h4(_templateObject5);

export var StyledModalText = styled.p(_templateObject6);